import { defineComponent } from "vue";
import index from "./MemberItem/index.mjs";
import Dialog from "../common/base/Dialog/index.mjs";
import useIndex from "./useIndexHooks.mjs";
import { storeToRefs } from "pinia";
import { useRoomStore } from "../../stores/room.mjs";
import SvgIcon from "../common/base/SvgIcon.vue.mjs";
import ApplyTipsIcon from "../common/icons/ApplyTipsIcon.vue.mjs";
import { USERS_STATUS } from "../../constants/room.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "indexH5",
  setup(__props) {
    const roomStore = useRoomStore();
    const {
      applyToAnchorList,
      isMicrophoneDisableForAllUser,
      isCameraDisableForAllUser,
      isGeneralUser
    } = storeToRefs(roomStore);
    const {
      audioManageInfo,
      videoManageInfo,
      showManageAllUserDialog,
      dialogTitle,
      dialogContent,
      ManageControlType,
      toggleManageAllMember,
      doToggleManageAllMember,
      t,
      handleToggleStaged,
      applyToAnchorUserContent,
      showApplyUserList,
      showMoreControl,
      moreControlList,
      toggleClickMoreBtn,
      userStatusList,
      currentActiveTabName,
      filteredUserStatusList,
      handleCallAllInvitee
    } = useIndex();
    return { __sfc: true, roomStore, applyToAnchorList, isMicrophoneDisableForAllUser, isCameraDisableForAllUser, isGeneralUser, audioManageInfo, videoManageInfo, showManageAllUserDialog, dialogTitle, dialogContent, ManageControlType, toggleManageAllMember, doToggleManageAllMember, t, handleToggleStaged, applyToAnchorUserContent, showApplyUserList, showMoreControl, moreControlList, toggleClickMoreBtn, userStatusList, currentActiveTabName, filteredUserStatusList, handleCallAllInvitee, MemberItem: index, Dialog, SvgIcon, ApplyTipsIcon, USERS_STATUS };
  }
});
export {
  _sfc_main as default
};
